module.exports = require('./lib/bezier');
